<div>
  <div class="card boxContainer">
    <div class="text-dark font-size-24 mb-4">
      <strong>Reset Password</strong>
    </div>
    <form nz-form [nzLayout]="'vertical'">
      <nz-form-item>
        <nz-form-control nzErrorTip="Please input your email!">
          <input type="text" nz-input nzSize="large" placeholder="Email Address" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" [nzSize]="'large'" class="text-center w-100">
            <strong>Reset my password</strong>
          </button>
        </nz-form-control>
      </nz-form-item>
    </form>
    <a routerLink="/auth/login" class="kit__utils__link font-size-16">
      <i-feather name="arrow-left" class="mr-1 align-middle"></i-feather>
      Go to Sign in
    </a>
  </div>
</div>
